import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericService } from "app/_services/generic.service";
import { serviceModel } from "./service-model";

@Injectable({
    providedIn: 'root'
  })
  export class purshaseService extends GenericService<serviceModel> {
    constructor(private http: HttpClient) {
      super(http, '/Service/')
  }
  
  getHelpPlansByService(){
    return this.http.get(
      this.url + "GetHelpPlansByService" ,
      this.prepareHeader()
    );
  }
  }